import { useQuery } from '@tanstack/react-query';
import { METABASE_API_URL, metabaseApi } from '../../core/api';
import { Collection, collectionsSchema } from '../../core/schemas/metabase';

export const QUERY_KEY_COLLECTIONS = 'collections';

const getCollectionId = (
  collections: Collection[] | undefined,
  predicate: (c: Collection) => boolean
): number | undefined => {
  const collection = collections?.find(predicate);
  return collection?.id ? Number(collection.id) : undefined;
};

export const useGetCollections = () => {
  const {
    data: collections,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [QUERY_KEY_COLLECTIONS],
    queryFn: async () => {
      const { data } = await metabaseApi.get(`${METABASE_API_URL}/collection`);

      const parsed = collectionsSchema.safeParse(data);

      if (!parsed.success) {
        throw new Error('Failed to parse collections');
      }

      return parsed.data;
    },
  });

  const rootCollectionId = getCollectionId(
    collections,
    c => c.location === '/' && c.is_personal
  );

  const snapshotCollectionId = getCollectionId(
    collections,
    c => c.name === 'temporary_drafts'
  );

  return {
    collections,
    rootCollectionId,
    snapshotCollectionId,
    isLoading,
    isError,
  };
};
